import { useState } from 'react';
import { patchAPI } from '../../services/api.service';

export function useEditUser() {
  const [loading, setLoading] = useState(false);

  const handleEditUser = async (userId: string, data: any) => {
    setLoading(true);
    try {
      const response = await patchAPI(`/auth/me?userId=${userId}`, data);
      if (response.status === 200) {
        console.log('User updated successfully');
      } else {
        console.error('Failed to update user:', response.error);
      }
    } catch (err) {
      console.error('Error updating user:', err);
    } finally {
      setLoading(false);
    }
  };

  return { handleEditUser, loading };
}